import { useState } from 'react';
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import AuthClient from '../../../api/AuthClient';
import GetFriendsInAppApi from '../../../api/GetFriendsInAppApi';
import { parseAppFriendsResponse } from '../../../api/parseResponse/parseAppFriendsResponse';
import { appFriends } from '../../../types';
interface ModalProps {
    showModal: boolean;
    handleCloseModal: () => void;

    showWarningModal?: boolean;
    handleCloseWarningModal?: () => void;

    showAgeWarningModal?: boolean;
    handleCloseAgeWarningModal?: () => void;

    showOverAgeWarningModal?: boolean;
    handleCloseOverAgeWarningModal?: () => void;

    groupId?: string;
    appFriends?: appFriends;
    selectedFriendIds?: string[];
}

const AddFriendsOptionsModal: React.FC<ModalProps> = ({ showModal, handleCloseModal, showWarningModal, handleCloseWarningModal, showAgeWarningModal,
    handleCloseAgeWarningModal, showOverAgeWarningModal, handleCloseOverAgeWarningModal, groupId, appFriends, selectedFriendIds }) => {

    const [confirmModal, setConfirmModal] = useState(false);
    const navigate = useNavigate();

    function navigateToAdd(type: string) {

        if (type === 'appFriend') {

            navigate("/appFriends", {
                state: { appFriends, groupId, selectedFriendIds }
            });

        } else {
            handleCloseModal();
            setConfirmModal(true);
        }
    }

    function navigateToAddFriends() {
        setConfirmModal(false);
        navigate("/addMalesOrFemales", {
            state: { groupId }
        });
    }

    return (
        <>
            <Modal
                backdrop={false}
                centered
                show={confirmModal}
                onHide={handleCloseModal}
            >
                <Modal.Header>
                    Invite Friends
                </Modal.Header>
                <Modal.Body>
                    Only use this option if you do not have the guests as friends in app and they are not in your phone contacts.
                    Are you sure you do not want to invite from your contacts?
                </Modal.Body>
                <Modal.Footer>
                    <button className="link btns btnMO justify-content-center d-flex align-content-center col-12 mb-2" onClick={navigateToAddFriends} >
                        Yes
                    </button>
                    <button
                        className="link btns btnMO justify-content-center d-flex align-content-center col-12 mb-2"
                        onClick={() => { setConfirmModal(false) }}
                    >
                        No
                    </button>
                </Modal.Footer>
            </Modal>


            <Modal
                backdrop={false}
                centered
                show={showModal}
                onHide={handleCloseModal}
            >
                <Modal.Header>
                    Invite Friends
                </Modal.Header>
                <Modal.Body>
                    <div className="mt-3">
                        <button className="link btns btnMO justify-content-center d-flex align-content-center col-12 mt-2 mb-2" onClick={() => navigateToAdd("appFriend")}>
                            Friends in app
                        </button>

                        <button className="link btns btnMO justify-content-center d-flex align-content-center col-12 mt-2 mb-2" onClick={() => navigateToAdd("girl-boy")}>
                            Females / Males
                        </button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="link btns btnMO justify-content-center d-flex align-content-center col-12 mb-2"
                        onClick={handleCloseModal}
                    >
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal>


            <Modal
                backdrop={false}
                centered
                show={showWarningModal}
            >
                <Modal.Header>
                    Invite Friends
                </Modal.Header>
                <Modal.Body>
                    Please add a friend to continue
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="link btns btnMO justify-content-center d-flex align-content-center col-12 mb-2"
                        onClick={handleCloseWarningModal}
                    >
                        Ok
                    </button>
                </Modal.Footer>
            </Modal>


            <Modal
                backdrop={false}
                centered
                show={showAgeWarningModal}
            >
                <Modal.Body>
                    Age has to be 18+ to join clubbable
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="link btns btnMO justify-content-center d-flex align-content-center col-12 mb-2"
                        onClick={handleCloseAgeWarningModal}
                    >
                        Ok
                    </button>
                </Modal.Footer>
            </Modal>


            <Modal
                backdrop={false}
                centered
                show={showOverAgeWarningModal}
            >
                <Modal.Body>
                    Your friends is probably a bit too old to go out :)
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="link btns btnMO justify-content-center d-flex align-content-center col-12 mb-2"
                        onClick={handleCloseOverAgeWarningModal}
                    >
                        Ok
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddFriendsOptionsModal